import { ModulesGuard } from './guards/modules.guard';
import { CryptService } from './services/crypt.service';
import { AuthPaymentGuardService } from './guards/auth-payment-guard.service';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuardService } from './guards/auth-guard.service';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { NoAuthGuardService } from './guards/no-auth-guard.service';
import { HttpService } from './services/http.service';
import { AuthService } from './services/auth/auth.service';
import { ExtractionService } from './services/extraction/extraction.service';
//import { HttpRequestInterceptor } from './interceptors/http-request-interceptor';
//import { NgxSoapModule } from 'ngx-soap';
import { HttpSoap } from './services/http-soap.service';
import { UploadFileManuallyService } from './services/upload-file-manually/upload-file-manually.service';
import { HttpRequestInterceptor } from './interceptors/http-request-interceptor';
import { XmlFormatSettingService } from './services/xml-format-setting/xml-format-setting.service';
import { EditThirdService } from './services/third-party/edit-third.service';
import { LoadPeriodTableService } from './services/load-period-table/load-period-table.service';
import { CompareBalanceService } from './services/compare-balance/compare-balance.service';
import { ValuesListService } from "./services/admin/values-list.service";
import { ReportsService } from './services/reports/reports.service';
import { ProcessExtractionService } from './services/process-extraction/process-extraction.service';
import { LegalEntityService } from "./services/legal-entity/legal-entity.service";
import { UploadFileAutomaticService } from './services/upload-file-automatic/upload-file-automatic.service';
import { BalanceThirdService } from './services/third-party/balance-third.service';
import { AutomaticDataGenerationService } from './services/automatic-data-generation/automatic-data-generation.service';
import { WebsocketService } from '../core/services/websocket/websocket.service'
import { TaskSchedulerService } from './services/task-scheduler/task-scheduler.service';
import { MassiveUpdateService } from './services/admin/massive-update.service';
import { DocumentService } from './services/document/document.service';
import { ValuesListDoeqService } from './services/document/values-list-doeq.service';
import { SocketService } from './services/websocket/socket.service';
import { MagneticMediaDistrictService } from './services/magnetic-media-district/magnetic-media-district.service';
import { UpdateProvidersService } from './services/document/update-providers.service';
import { PaymentService } from './services/payment/payment.service';
import { NoAuthPaymentGuardService } from './guards/no-auth-payment-guard.service';
import { ProcessFndService } from './services/process-fnd/process-fnd.service';
import { PermissionGuard } from './guards/permission.guard';
import { ReceptionAdvancedService } from './services/reception-advanced/reception-advanced.service';

@NgModule({
    imports: [
        HttpClientModule,
    ],
    providers: [
        AuthGuardService,
        NoAuthGuardService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpRequestInterceptor,
            multi: true
        },
        HttpService,
        AuthService,
        ExtractionService,
        HttpSoap,
        UploadFileManuallyService,
        XmlFormatSettingService,
        EditThirdService,
        LoadPeriodTableService,
        CompareBalanceService,
        ValuesListService,
        ReportsService,
        ProcessExtractionService,
        LegalEntityService,
        UploadFileAutomaticService,
        BalanceThirdService,
        AutomaticDataGenerationService,
        WebsocketService,
        TaskSchedulerService,
        MassiveUpdateService,
        DocumentService,
        ValuesListDoeqService,
        SocketService,
        MagneticMediaDistrictService,
        UpdateProvidersService,
        PaymentService,
        AuthPaymentGuardService,
        NoAuthPaymentGuardService,
        CryptService,
        ProcessFndService,
        ModulesGuard, 
        PermissionGuard,
        ReceptionAdvancedService,
    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        this.throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }

    throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
        if (parentModule) {
            throw new Error(`${moduleName} has already been loaded. Import ${moduleName} modules in the AppModule only.`);
        }
    }
}





// WEBPACK FOOTER //
// ./src/app/core/core.module.ts